import { ref } from 'vue';
export default {
  name: "Tumbler",

  data() {
    return {
      switchers: []
    };
  },

  props: {
    switcherOnClick: Function,
    mode: {
      type: String,
      default: 'ONLY_ONE',

      validator(value) {
        return ['ONLY_ONE', 'NONE_OR_ONE', 'ANY'].includes(value);
      }

    } //firstOpened: Boolean,

  },
  methods: {
    switcherShow(switcher) {
      switch (this.mode) {
        case "ONLY_ONE":
          this.switchers.forEach(child => {
            if (child != switcher) {
              child.close();
            }
          });
          break;

        case "NONE_OR_ONE":
          if (switcher.isDisplayed()) {
            switcher.close();
          }

          this.switchers.forEach(child => {
            if (child != switcher) {
              child.close();
            }
          });
          break;
      }
    },

    addSwitcher(switcher) {
      if (this.switchers.indexOf(switcher) < 0) {
        this.switchers.push(switcher);
      }
    },

    removeSwitcher(switcher) {
      const indexOfSwitcher = this.switchers.indexOf(switcher);

      if (indexOfSwitcher >= 0) {
        this.switchers.splice(indexOfSwitcher, 1);
      }
    }

  },

  mounted() {//if (this.$props.firstOpened) {
    //  console.log(['Tumbler', this.$slots.default()]);
    //  let el = this.$slots.default()[0];
    //  el && el.show();
    //}
  }

};